function handleLoader(isShow: boolean) {
  const loader = document.getElementById('app-loader')
  if (loader) {
    if (isShow) {
      loader.style.display = 'block'
    } else {
      loader.style.display = 'none'
    }
  } else {
    console.error('No element with ID "app-loader" found.')
  }
}

export default {
  show() {
    handleLoader(true)
  },
  hide() {
    handleLoader(false)
  }
}
